import React, {useEffect} from 'react';
import {useTimer} from 'react-timer-hook';
import "./timer.scss";

interface ITimer {
    expiryTimestamp: Date
}

function Timer({expiryTimestamp}: ITimer) {
    const {
        seconds,
        minutes,
        hours,
        days,
        isRunning,
        start,
        pause,
        resume,
        restart,
    } = useTimer({expiryTimestamp, onExpire: () => console.warn('onExpire called')});

    useEffect(() => {
        start();
    }, [])
    return (
        <div className="Timer">
            <span className="Timer-Label">زمان باقی مانده تا ارسال مجدد کد</span>
            <div className="Timer-Counter">
                <span>0{minutes}</span>:<span>{seconds}</span>
            </div>
        </div>
    );
}

export default Timer;